import Immerable from '@naruto/naruto-models/src/types/GeneralImmer';

class UrlParser extends Immerable {
  /**
   * 名稱 : normalizeBase
   * 功能 : 標準化路徑名稱
   */
  normalizeBase = (s: string): string => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

  /**
   * 名稱 : escapeRegExp
   * 功能 : 將路徑轉成正則可用的字串
   */
  escapeRegExp = (s: string): string => (s !== '/' ? s.replace(/\/+$/, '') : '/');

  /**
   * 名稱 : getValidBackUrl
   * 功能 : 取得合法上一頁的路徑
   */
  getValidBackUrl = (
    validUrls: string[],
    checkedUrls: string[],
    currentUrl = window ? window.location.pathname : ''
  ): string | undefined => {
    const validators = validUrls
      .filter(Boolean)
      .map(this.normalizeBase)
      .map(base => {
        const pattern = `^${this.escapeRegExp(base)}(?:/|$|\\?)`;
        return new RegExp(pattern);
      });

    if (validators.length === 0) return undefined;

    for (const url of checkedUrls) {
      // 只處理字串，且避免取到當前的 URL
      if (typeof url === 'string' && (!currentUrl || url !== currentUrl)) {
        for (const re of validators) {
          if (re.test(url)) return url;
        }
      }
    }

    return undefined;
  };

  /**
   * 名稱 : getFileType
   * 功能 : 取得檔案類型
   */
  getFileType = (url: string): string => {
    const split = url.split('.');
    return split[split.length - 1];
  };
}

export default UrlParser;
